import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import MaterialModal from "../MaterialModal";
import { hideModal } from "../../../actions/actionCreators";
import withModal from "../withModal";

const ArchiveModal = ({ modalProps, isOpen }) => {
    const dispatch = useDispatch();

    const hide = () => dispatch(hideModal("ARCHIVE"));

    const archive = () => {
        let folder = 0;
        if (modalProps.isActive === "N") {
            if (modalProps.isDestination) {
                folder = modalProps.folders.find(x => x.name === "Destination Layouts" && x.folderType === "L");
            } else {
                folder = modalProps.folders.find(x => x.name === "Saved Layouts" && x.folderType === "L");
            }
            modalProps.restoreActionCreator(modalProps.archiveId, modalProps.isDestination, folder.id);
        } else {
            folder = modalProps.folders.find(x => x.name === "Archived Layouts" && x.folderType === "L");
            modalProps.archiveActionCreator(modalProps.archiveId, folder.id);
        }
        hide();
    };

    return (
        <MaterialModal
            id="archive-modal"
            isOpen={isOpen}
            title={modalProps.isActive == "N" ? "Restore " : "Archive " + modalProps.archiveType + "?"}
            primaryButtonText="Yes"
            onClose={hide}
            onPrimaryButtonRequest={archive}
        >
            {modalProps.isActive == "N" ? "Restore " : "Archive "}the following {modalProps.archiveType}:{" "}
            {modalProps.archiveName}?
        </MaterialModal>
    );
};

ArchiveModal.propTypes = {
    // Injected from Redux
    modalProps: PropTypes.object,
    isOpen: PropTypes.bool,
    hideModal: PropTypes.func,
};

export default withModal(ArchiveModal, "ARCHIVE");
